export const OnboardingVideoRoutes = [
    {
        "url": "/dashboard",
        "name": "appLayout.harriSH.dashboard",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            brand: null,
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Dashboard"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding-video"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-video/onboarding-video.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/documents/:prospect_id?type&brandId",
        "enableUTM": true,
        "name": "documents",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": "obCandidateSignPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding-video"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-video/onboarding-video.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=onboarding-video.routes.js.map